import React, { useState, useContext } from "react";
import { Form, Container, Row, Col, Button, Image } from "react-bootstrap";
import { NavbarLogin } from "../../Components/Components";
import {
  BrowserRouter as Router,
  Redirect,
  useHistory,
} from "react-router-dom";
import "./Login.css";
import { AuthContext } from "../../auth/AuthContext";
import { types } from "../../types/types";

export const Login = ({ initState, updateState, loadData }) => {
  const [view, setView] = useState("form");

  let history = useHistory();

  const { usuario, dispatch } = useContext(AuthContext);

  if (usuario.logged) return <Redirect to="/dashboard" />;

  // if(view==='loading'){
  //   return(
  //     <React.Fragment>
  //       <h3>Cargando datos iniciales...</h3>
  //     </React.Fragment>
  //   )
  // }

  return (
    <React.Fragment>
      <NavbarLogin />
      <Container style={{ paddingTop: 80 }}>
        <Row>
          <Col xs={12} md={{ span: 6, offset: 3 }}>
            <div className="ws_box_login text-center">
              <Image
                src={"./img/logo.png"}
                alt="logo"
                style={{ width: 150, height: 150, marginTop: 20 }}
              />
              <Form onSubmit={handleSubmit} className="text-start mt-5">
                <Form.Group className="mb-2">
                  <Form.Label>Usuario</Form.Label>
                  <Form.Control
                    className="ws_shadow_input"
                    type="text"
                    id="user"
                    name="user"
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-2">
                  <Form.Label>Contraseña</Form.Label>
                  <Form.Control
                    className="ws_shadow_input"
                    type="password"
                    id="password"
                    name="password"
                    required
                  />
                </Form.Group>
                {/* <Form.Group className="mb-2" controlId="formCheck">
                  <Form.Check type="checkbox" id="recordar" name="recordar" label="Recordarme en este navegador" />
                </Form.Group> */}
                {/* <Form.Group className="mb-2">
                  <div className="text-end">
                    <p style={{color:'#0ca1b4'}}>No recuerdas tu contraseña da <a href="#" style={{color:'#0ca1b4'}}>click aquí</a></p>
                  </div>
                </Form.Group> */}
                <Form.Group className="mb-2 mt-4">
                  <div className="d-grid gap-2">
                    <Button
                      type="submit"
                      className="btn btn-primary ws_btn_secundary"
                      style={{ borderRadius: 5 }}
                      disabled={view === "loading" ? true : false}
                    >
                      {view === "loading" ? "Ingresando..." : "Ingresar"}
                    </Button>
                  </div>
                </Form.Group>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );

  function handleSubmit(e) {
    e.preventDefault();

    // updateState({
    //   data: {},
    //   dataGrafica: [],
    //   dataOficinas: {},
    //   oficinas: [],
    //   profileOficinas: [],
    //   profileOficinasAgentes:[],
    //   viewOficinaData: {},
    // })
    setView("loading");

    const data = new FormData(e.currentTarget);

    fetch("https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=login", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({
        user: data.get("user"),
        password: data.get("password"),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "ok") {
          // setView('loading')
          getInitDashboard(data.id_usuario, data);
        } else {
          setView('form')
          alert("Usuario o contraseña incorrectos");
        }
      });
  }

  function getInitDashboard(id_login = "", response) {
    const { data } = initState;

    const today = new Date();
    const year = today.getFullYear();
    const month = ("0" + (today.getMonth() + 1)).slice(-2);
    const day = ("0" + today.getDate()).slice(-2);

    const values = {
      id_login: id_login,
      opt: "0",
      oficinas: [],
      agentes: "0",
      tipo_agente: "0",
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getInitDashboard`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(values),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        data[0] = res;
        updateState({
          data,
          loadingData: false,
          oficinas: res.oficinas,
        });
        dispatch({
          type: types.login,
          payload: {
            direccion: response.direccion,
            empresa: response.empresa,
            id_usuario: response.id_usuario,
            nombre: response.nombre,
            tipo: response.tipo,
            usuario: response.usuario,
            date_login: `${year}-${month}-${day}`,
          },
        });
        if(response.tipo=="3"){
          history.replace("/agentes");
        }else{
          history.replace("/");
        }
      });
  }
};
